import { render } from "./TrainingStatsView.vue?vue&type=template&id=c0eb31d8&scoped=true&ts=true"
import script from "./TrainingStatsView.vue?vue&type=script&lang=ts"
export * from "./TrainingStatsView.vue?vue&type=script&lang=ts"

import "./TrainingStatsView.vue?vue&type=style&index=0&id=c0eb31d8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0eb31d8"]])

export default __exports__